import { c as _c } from "react/compiler-runtime";
import type { FanInMessage } from '@module/types/centrifuge/public-message/inMessageTypes';
interface Props {
  item: FanInMessage;
}
export default function FanInChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `열혈 팬클럽 ${message.nick} 님께서 입장하셨습니다.`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_entr_fh"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}